import SupportRequestChild from './SupportRequestChild'
import './NotificationsParent.css'
import { SupportRequestObject } from '../../interfaces/APIInterface'
import { useState } from 'react';
import KeyboardArrowUpSharpIcon from '@mui/icons-material/KeyboardArrowUpSharp';
import Button from '@mui/material/Button';

const SupportRequestsParent = (props: any) => {

    const [isLoading, setIsLoading] = useState(false);

    const reloadSupportRequests = () => {
        setIsLoading(true);
        props.callSupportRequestsAPI()
            .then(() => setIsLoading(false));
    }

    const handleClick = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    return (
        <>
            {isLoading ? <span className="working">Loading</span> : <div className="container">
                <h1 className="page-title"> All Support Requests </h1>
                <div className="support-buttons row">
                    <Button onClick={reloadSupportRequests} ><i className="fa fa-refresh"></i> Refresh Support Requests</Button>
                </div>
                {props.supportRequestsList.map((supportRequest: SupportRequestObject) => (
                    <SupportRequestChild
                        key={supportRequest.id}
                        callSupportRequestsAPI={props.callSupportRequestsAPI}
                        allApplications={props.allApplications}
                        supportRequest={supportRequest}
                    />
                ))}
                <Button className="jump-top" onClick={handleClick}><KeyboardArrowUpSharpIcon /></Button>
            </div>
            }
        </>
    )
}

export default SupportRequestsParent
